import React from "react";
import ReactApexChart from "react-apexcharts";

interface OrganizationTypeData {
    organization_type: string;
    count: number;
}

interface Props {
    organizationTypeDistribution: OrganizationTypeData[];
}

const OrganizationTypeDistributionTreeMap: React.FC<Props> = ({
    organizationTypeDistribution,
}) => {
    const fillColor = "#7C9EFF";
    const data = (organizationTypeDistribution || []).map((entry) => ({
        x: entry.organization_type,
        y: entry.count,
        fillColor,
    }));

    const options = {
        chart: {
            type: "treemap" as const,
        },
        title: {
            align: "center" as const,
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: "18px",
                color: "#263238",
            },
        },
        legend: {
            show: true,
            position: "bottom" as const,
        },
    };

    return (
        <div>
            <ReactApexChart
                options={options}
                series={[{ data }]}
                type="treemap"
                height={350}
            />
        </div>
    );
};

export default OrganizationTypeDistributionTreeMap;
